import { useEffect, useState } from "react"
import { FieldType, FieldValue, FormField, O, Option, option } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { useSupplierLoaders } from "../../../loaders/supplierLoaders"

type Props = {
    defaultValue?: string,
    value?: string,
    productSupplier?: boolean
    disabled?: boolean
    narrow?: boolean
    focus?: boolean
    onChange?: (value?: FieldValue) => void
    onCreateNew?: () => void
}

export const SupplierField = (props: Props): FormField => {
    const { defaultValue, value, productSupplier = true, disabled, narrow, focus, onChange, onCreateNew } = props

    const [stateValue, setStateValue] = useState<O<string>>(value)
    const [options, setOptions] = useState<Option[]>([])
    
    const supplierLoaders = useSupplierLoaders()

    const loadOptions = async () => {
        const { loadTypeSuppliers } = supplierLoaders()
        const suppliers = await loadTypeSuppliers(productSupplier)
        const newOptions = suppliers
            .filter(supplier => supplier.id === value || !supplier.archived)
            .map(supplier => option(supplier.id, supplier.name))
        setOptions(newOptions)
    }
    
    useEffect(() => {
        loadOptions()
    }, [productSupplier])

    useEffect(() => {
        if (value && !options.map(option => option.value).includes(value)) {
            loadOptions().then(() => setStateValue(value))
        } else {
            setStateValue(value)
        }
    }, [value])

    return {
        name: 'supplierId',
        type: FieldType.TABLE,
        table: TableName.SUPPLIERS,
        label: 'Proveedor',
        defaultValue,
        value: stateValue,
        options,
        disabled,
        narrow,
        focus,
        onChange,
        onCreateNew
    }
}
